import { render } from "./FeaturedJobs.vue?vue&type=template&id=cad9770e&scoped=true"
import script from "./FeaturedJobs.vue?vue&type=script&lang=js"
export * from "./FeaturedJobs.vue?vue&type=script&lang=js"

import "./FeaturedJobs.vue?vue&type=style&index=0&id=cad9770e&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cad9770e"]])

export default __exports__